import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// Format currency (Chilean Pesos)
export function formatCurrency(amount) {
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount || 0);
}

// Format date
export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('es-CL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

// Format datetime
export function formatDateTime(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('es-CL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

// Get today's date in YYYY-MM-DD format
export function getTodayDate() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Status labels
export const statusLabels = {
  // Client statuses
  activo: 'Activo',
  congelado: 'Congelado',
  cancelado: 'Cancelado',
  
  // Task statuses
  pendiente: 'Pendiente',
  en_curso: 'En Curso',
  hecho: 'Hecho',
  vencida: 'Vencida',
  
  // Lead statuses
  nuevo: 'Nuevo',
  pendiente_contacto: 'Pendiente de Contacto',
  contactado: 'Contactado',
  agendo_clase_prueba: 'Agendó Clase de Prueba',
  no_responde: 'No Responde',
  interesado: 'Interesado',
  convertido: 'Convertido',
  descartado: 'Descartado',
  
  // Rejected payment statuses
  regularizado: 'Regularizado',
  recuperado: 'Recuperado',
  no_recuperado: 'No Recuperado',
  cancela_suscripcion: 'Cancela Suscripción',
  
  // Operational case statuses
  abierto: 'Abierto',
  cerrado: 'Cerrado',
  
  // Cash register
  abierta: 'Abierta',
  cerrada: 'Cerrada',
};

// Operational case action type labels
export const movementTypeLabels = {
  nuevo_cliente: 'Nuevo Cliente',
  renovacion: 'Renovación',
  cambio_plan: 'Cambio de Plan',
  congelacion: 'Congelación',
  descongelacion: 'Descongelación',
  cancelacion: 'Cancelación',
};

// Check status labels
export const checkStatusLabels = {
  ok: 'OK',
  pendiente: 'Pendiente',
  no_aplica: 'N/A',
  enviado: 'Enviado',
  si: 'Sí',
};

// Cash categories
export const cashCategories = [
  { value: 'merch', label: 'Merch' },
  { value: 'frigobar', label: 'Frigobar' },
  { value: 'plan', label: 'Plan' },
  { value: 'clase_prueba', label: 'Clase de Prueba' },
  { value: 'clase_extra', label: 'Clase Extra' },
  { value: 'gasto', label: 'Gasto' },
  { value: 'ingreso', label: 'Ingreso' },
];

// Client origins
export const clientOrigins = [
  { value: 'virtualpos', label: 'Virtual POS' },
  { value: 'shopify', label: 'Shopify' },
  { value: 'manual', label: 'Manual' },
  { value: 'pos_presencial', label: 'POS Presencial' },
  { value: 'transferencia', label: 'Transferencia' },
];

// Priority labels
export const priorityLabels = {
  alta: 'Alta',
  media: 'Media',
  baja: 'Baja',
};

// Plans
export const plans = [
  'Essential x4',
  'Balance x8',
  'Glow x12',
  'Level Up x16',
  'My Grit Era x20',
  'SEMESTRAL ESSENTIAL',
  'SEMESTRAL BALANCE',
  'SEMESTRAL GLOW',
  'ANUAL BALANCE',
  'ANUAL GLOW',
  'GIFT CARD',
  'Clase de Prueba',
];

// Payment methods
export const paymentMethods = [
  { value: 'efectivo', label: 'Efectivo' },
  { value: 'tarjeta', label: 'Tarjeta' },
  { value: 'transferencia', label: 'Transferencia' },
];

// Get status class
export function getStatusClass(status) {
  const classes = {
    activo: 'status-activo',
    congelado: 'status-congelado',
    cancelado: 'status-cancelado',
    pendiente: 'status-pendiente',
    en_curso: 'status-pendiente',
    hecho: 'status-activo',
    vencida: 'status-cancelado',
    nuevo: 'badge-warning',
    pendiente_contacto: 'status-pendiente',
    contactado: 'status-activo',
    agendo_clase_prueba: 'status-activo',
    no_responde: 'status-congelado',
    interesado: 'status-activo',
    convertido: 'status-activo',
    descartado: 'status-cancelado',
    regularizado: 'status-activo',
    recuperado: 'status-activo',
    no_recuperado: 'status-cancelado',
    cancela_suscripcion: 'status-cancelado',
    abierto: 'badge-warning',
    cerrado: 'status-activo',
    abierta: 'status-activo',
    cerrada: 'status-pendiente',
  };
  return classes[status] || 'status-pendiente';
}

// Get priority class
export function getPriorityClass(priority) {
  const classes = {
    alta: 'priority-alta',
    media: 'priority-media',
    baja: 'priority-baja',
  };
  return classes[priority] || 'priority-media';
}
